import {validateEmail} from "./validateEmail";
import {checkEmptyFields} from "./checkEmptyFields";
import {STRICT_NAME_REGEX} from "../../constants";

export const checkFormField = ( _this ) => {
	_this.closest(`li.empty`) ? _this.closest(`li.empty`).classList.remove(`empty`) : false;
	_this.closest(`li.invalid`) ? _this.closest(`li.invalid`).classList.remove(`invalid`) : false;
	
	if ( _this.hasAttribute(`disabled`) )
	{
		return;
	}
	
	const val = _this.value;
	const type = _this.getAttribute(`data-type`);

	if ( type )
	{
		if ( type === `email` )
		{
			if ( val.length < 1 || !validateEmail( val ) )
			{
				_this.closest( `li` ).classList.add( `invalid` );
			}
		}

		if ( type === `checkbox` )
		{
			if ( !_this.checked )
			{
				_this.closest( `li` ).classList.add( `invalid` );
			}
		}

		if ( type === `phone` )
		{
			// Старая стандартная проверка
			// if ( !/^[0-9\+\s\(\)\-]{5,20}$/.test( val ) )
			// Новая проверка выполняет требование минимум 11 цифр в телефоне для номеров стран СНГ
			if ( !/^(8|7|\+374|\+994|\+995|\+375|\+7|\+380|\+38|\+996|\+998|\+993)([\-\s\(\)]*\d){10,15}[\s\)]*$/.test( val.trim() ) )
			{
				_this.closest(`li`).classList.add(`invalid`);
			}
		}

		if ( type === `file` && val === `` )
		{
			_this.closest( `li` ).classList.add( `invalid` );
		}

		if ( type === `phone-or-email` )
		{
			if ( ( val.length < 1 || !validateEmail( val ) ) && !/^[0-9\+\s\(\)\-]{5,20}$/.test( val ) )
			{
				_this.closest(`li`).classList.add(`invalid`);
			}
		}

		if ( type === `radios` )
		{
			if ( !_this.form.querySelector(`input[name="${_this.name}"]:checked`) )
			{
				_this.closest(`ul.fields > li`).classList.add(`invalid`);
			}
		}

		if ( type === `date` )
		{
			if ( val.replace(/\D+/g,``).length < 8 )
			{
				_this.closest(`ul.fields > li`).classList.add(`invalid`);
			}
		}

		if ( type === `strict-name` )
		{
			if ( val.trim().length < 1 || !STRICT_NAME_REGEX.test( val ) )
			{
				_this.closest(`li`).classList.add(`invalid`);
			}
		}

	} else
	{
		if ( val.length < 1 )
		{
			_this.closest( `li` ).classList.add( `invalid` );
		}
	}

	checkEmptyFields(_this);
};
